import React from 'react';
import { useSelector, connect } from 'react-redux';
import Forum from '@material-ui/icons/Forum';

const ChatWidgetIcon = (props) => {
  const styles = {
    button: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      backgroundColor: '#f47e46',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      cursor: 'pointer',
      zIndex: 1000,
      border: 'none',
      transition: 'transform 0.3s, box-shadow 0.3s',
    },
    buttonHover: {
      transform: 'scale(1.1)',
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
    },
    icon: {
      fontSize: '35px', // Adjust size to match Forum icon
    },
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = styles.buttonHover.transform;
    e.currentTarget.style.boxShadow = styles.buttonHover.boxShadow;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = 'none';
    e.currentTarget.style.boxShadow = styles.button.boxShadow;
  };

  return (
    <button
      style={styles.button}
      onClick={props.onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title="Group Chat"
    >
      <Forum style={styles.icon} />
    </button>
  );
};

// export default ChatWidgetIcon;
export default connect(null, {})(ChatWidgetIcon);

